module.exports = __webpack_public_path__ + "img/legal.db9e7306.svg";